const GRID_LAYER = 'gantt_grid_data';
const BARS_LAYER = 'gantt_bars_area';
const isUpdating = {
  [GRID_LAYER]: false,
  [BARS_LAYER]: false
};

/**
 * Handles scroll events for lookahead chart layers with performance optimizations
 * @param {Object} gantt - The Gantt instance
 * @param {Object} layer - The layer being scrolled
 * @param {Object} view - The view configuration
 */

function lookaheadScrollHandler(gantt, layer, view) {
  const state = gantt.$services.getService('state');
  if (
    state.getState('batchUpdate').batch_update ||
    view.$config.$skipSmartRenderOnScroll
  ) {
    return;
  }

  if (layer.requestUpdate) {
    if (!layer.container || !layer.container.className) {
      layer.requestUpdate();
      return;
    }

    const layerName = layer.container.className;

    if (layerName.includes(GRID_LAYER) || layerName.includes(BARS_LAYER)) {
      const layerKey = layerName.includes(GRID_LAYER) ? GRID_LAYER : BARS_LAYER;

      if (!isUpdating[layerKey]) {
        isUpdating[layerKey] = true;
        requestAnimationFrame(() => {
          layer.requestUpdate();
          isUpdating[layerKey] = false;
        });
      }
    } else {
      layer.requestUpdate();
    }
  }
}

export { lookaheadScrollHandler };
